import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.set-prototype-of";
import "core-js/modules/es6.regexp.split";
import "core-js/modules/es6.function.name";
import _isNaN from "lodash/isNaN";
import _get from "lodash/get";
import _find from "lodash/find";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Split Date Input
 *
 * This component makes it convenient for the user to enter dates with format MM/DD/YYYY.
 * It has 3 input fields where focus is automatically moved to the next field when typing/ deleting.
 * This can be used in favor of (or combination with) the regular FormattedInput because certain mobile devices fire events differently which causes inconsistent behavior.
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Input from '@nerdwallet/react-input';
import classes from '@nerdwallet/base-styles/classes';
/**
 * @constant - array of date field objects
 * @property {string} name - The name of the date field.
 * @property {number} length - The max length the date field value can have.
 * @property {string} next - The next date field to focus when current field value reaches max length.
 * @property {string} prev - The previous date field to focus when current field value reaches 0.
 */

var DATE_FIELDS = [{
  name: 'month',
  length: 2,
  next: 'day'
}, {
  name: 'day',
  length: 2,
  next: 'year',
  prev: 'month'
}, {
  name: 'year',
  length: 4,
  prev: 'day'
}];

var SplitDateInput =
/*#__PURE__*/
function (_Component) {
  _inherits(SplitDateInput, _Component);

  function SplitDateInput(props) {
    var _this;

    _classCallCheck(this, SplitDateInput);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SplitDateInput).call(this, props));
    _this.onBlur = _this.onBlur.bind(_assertThisInitialized(_this));
    _this.onChange = _this.onChange.bind(_assertThisInitialized(_this));
    /**
     * Input dom elements obtained via refs
     */

    _this.inputs = {};
    /**
     * State is used to display month, day, year and complete date values for the inputs.
     * Although there is internal state, this is a controlled component because when we receive the prop "value" we parse it into the state.
     * State is just used as an intermediate to construct the full date string we then pass to this.props.onChange.
     * In future this should be changed as it's an antipattern to the framework.
     */

    _this.state = {
      date: props.value,
      day: '',
      month: '',
      year: ''
    };
    return _this;
  }

  _createClass(SplitDateInput, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      // Parse props on initial render
      this.updateStateFromProps(this.props);
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      // Parse props on prop changes
      this.updateStateFromProps(nextProps);
    }
  }, {
    key: "onChange",
    value: function onChange(field, e) {
      var _this2 = this;

      var dateField = _find(DATE_FIELDS, {
        name: field
      });

      var prevValue = _get(this.state, dateField.name);

      var value = e.target.value; // Ignore if value hasn't changed or user inputed a non digit

      if (this.state[field] === value || _isNaN(value)) {
        return;
      } // Get the new state and construct date string from it


      var newState = _objectSpread({}, this.state, _defineProperty({}, field, value));

      var focusField = field;

      if (value.length > dateField.length) {
        // Typing in an already full field should move new digit to next field
        // If no next field, do nothing
        if (!dateField.next) {
          return;
        }

        focusField = dateField.next;
        newState = _objectSpread({}, this.state, _defineProperty({}, dateField.next, value.substring(value.length - 1)));
      } else if (value.length === dateField.length && dateField.next) {
        // Move focus to next field if current field is now full
        focusField = dateField.next;
      } else if (prevValue.length > 0 && value.length === 0 && dateField.prev) {
        // Move focus to previous field if current field is now empty
        focusField = dateField.prev;
      }

      this.setState(_objectSpread({}, newState, {
        date: "".concat(newState.month, "/").concat(newState.day, "/").concat(newState.year)
      }), function () {
        _this2.focus(focusField);

        _this2.props.onChange(_this2.state.date);
      });
    }
  }, {
    key: "onBlur",
    value: function onBlur(e) {
      e.preventDefault();
      this.props.onBlur(this.state.date);
    }
  }, {
    key: "focus",
    value: function focus(field) {
      var domNode = this.inputs[field];
      domNode.focus();
    }
  }, {
    key: "updateStateFromProps",
    value: function updateStateFromProps(props) {
      // Parse the prop "value" into three separate date fields
      var fieldValues = props.value.split('/');
      var newState = {
        month: fieldValues[0] || '',
        day: fieldValues[1] || '',
        year: fieldValues[2] || ''
      };
      var date = "".concat(newState.month, "/").concat(newState.day, "/").concat(newState.year);
      this.setState(_objectSpread({}, newState, {
        date: date
      }));
    }
    /* eslint-disable react/jsx-no-bind */

  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      return React.createElement("div", {
        className: classes('display-flex')
      }, React.createElement("div", null, React.createElement(Input, {
        inputRef: function inputRef(input) {
          _this3.inputs.month = input;
        },
        error: this.props.error,
        onChange: this.onChange.bind(null, 'month'),
        value: this.state.month,
        placeholder: "MM"
      })), React.createElement("div", null, React.createElement(Input, {
        inputRef: function inputRef(input) {
          _this3.inputs.day = input;
        },
        error: this.props.error,
        onChange: this.onChange.bind(null, 'day'),
        value: this.state.day,
        placeholder: "DD"
      })), React.createElement("div", null, React.createElement(Input, {
        inputRef: function inputRef(input) {
          _this3.inputs.year = input;
        },
        error: this.props.error,
        onChange: this.onChange.bind(null, 'year'),
        onBlur: this.onBlur,
        value: this.state.year,
        placeholder: "YYYY"
      })));
    }
    /* eslint-enable react/jsx-no-bind */

  }]);

  return SplitDateInput;
}(Component);

_defineProperty(SplitDateInput, "displayName", 'SplitDateInput');

_defineProperty(SplitDateInput, "propTypes", {
  value: PropTypes.string.isRequired,
  error: PropTypes.bool,
  onChange: PropTypes.func,
  onBlur: PropTypes.func
});

_defineProperty(SplitDateInput, "defaultProps", {
  onChange: function onChange() {},
  onBlur: function onBlur() {},
  error: false
});

export { SplitDateInput as default };